var loadAgentFromCDN = function (key, applicationType) {
    if (applicationType === void 0) { applicationType = 'SPA'; }
    window['adrum-start-time'] = new Date().getTime();
    (function (config) {
        config.appKey = key;
        config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
        config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
        config.beaconUrlHttp = 'http://fra-col.eum-appdynamics.com';
        config.beaconUrlHttps = 'https://fra-col.eum-appdynamics.com';
        //config.xd = { enable: false };
        config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
        config.maxUrlLength = 512;
        config.spa = { spa2: applicationType === 'SPA' };
    })(window['adrum-config'] || (window['adrum-config'] = {}));
    require('./adrum.js');
};
/*
 * Return string for local embedding of browser agent
 * eg:
 * const appDynamicsLoadJS = appdynamics.loadAgentClientStr('AD-AAB-AAJ-XVV', true);
 * {!isLocalDev && <script defer dangerouslySetInnerHTML={{ __html: appDynamicsLoadJS }} />}
 * */
var loadAgentClientStr = function (key, spa2) {
    if (spa2 === void 0) { spa2 = false; }
    return "var key='" + key + "'; console.log('appdAgent loading');  window['adrum-start-time'] = new Date().getTime(); (function(config){ config.appKey = key; config.adrumExtUrlHttp = 'http://cdn.appdynamics.com'; config.adrumExtUrlHttps = 'https://cdn.appdynamics.com'; config.beaconUrlHttp = 'http://col.eum-appdynamics.com'; config.beaconUrlHttps = 'https://col.eum-appdynamics.com'; config.xd = {enable : false}; config.spa = { 'spa2': " + spa2 + " }; })(window['adrum-config'] || (window['adrum-config'] = {})); ";
};
/*
 * Return url for main javascript code.
 * will extend to support locally hosted code (e.g. adrum.js)
 */
var mainJSUrl = function () {
    return '//cdn.appdynamics.com/adrum/adrum-latest.js';
};
/*
 * Include using require, main body of Javascript from this package
 */
var loadMainJS = function () {
    require('./adrum.js');
};

export default loadAgentFromCDN;
export { loadAgentClientStr, loadMainJS, mainJSUrl };
//# sourceMappingURL=index.esm.js.map
